/* eslint-disable arrow-body-style */
import { createSlice } from '@reduxjs/toolkit';
import { getCurrentTime, getDateWithDifference } from 'utils/time';

const initialState = {
    currentTime: null,
    previousTime: null,
    label: null,
    interval: 0,
    apiInterval: 0,
    intervalCount: 0,
    intervalId: null,
    range: null,
};

export const timeSlice = createSlice({
    name: 'timeSlice',
    initialState,
    reducers: {
        setTime: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
        setAppInterval: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
        initiateInterval: state => {
            let newTime = {
                currentTime: state.currentTime,
                previousTime: state.previousTime,
            };
            if (state.range?.value) {
                const currentTime = getCurrentTime();
                const previousTime = getDateWithDifference({
                    currentTime,
                    ...state.range.value,
                });
                newTime = {
                    currentTime,
                    previousTime,
                };
            }
            return {
                ...state,
                ...newTime,
                intervalCount: state.intervalCount + 1,
            };
        },
    },
});

export const getTimeAttributes = state => state.time;

export const getIntervalCount = state => state.time.intervalCount;

export const { setTime, setAppInterval, initiateInterval } = timeSlice.actions;
export default timeSlice.reducer;
